import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import ReactLoading from 'react-loading';

const Pricing_chart = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    useEffect(() => {
        // Fetch product pricing data
        const fetchPricingData = async () => {
          try {
            let sendData ={}
            let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/getProductPricing`;
            axios.post(full_api, sendData, { headers: exportValue.headers }).then((response) => {
               
                setProducts(response.data);
            setLoading(false);
    
            }).catch((error) => {
                console.error("Error fetching product pricing", error);
                setLoading(false);
    
            });
          } catch (error) {
            console.error("Error fetching product pricing", error);
            setLoading(false);
          }
         
          let sendData = {};
          // console.log("bb", sendData);
         
        };
    
        fetchPricingData();
      }, []);
  return (
    <div>
    <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
    <section className="home-section">
      <Sub_header />
      {products.length>0?
      products.map((product, productIndex) => (
          <div key={productIndex}>
              <h3>{product.product_name} ({product.mode})</h3>
              <table className="pricing-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                      <tr>
                          <th style={{ border: '1px solid #ddd', padding: '8px' }}>Weight Range (KG)</th>
                          {product.zones.map((zone, idx) => (
                              <th key={idx} style={{ border: '1px solid #ddd', padding: '8px' }}>{zone.zone_name}</th>
                          ))}
                      </tr>
                  </thead>
                  <tbody>
                      {product.groupedPricing.map((range, idx) => (
                          <tr key={idx}>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                  {range.start_range} - {range.end_range}
                              </td>
                              {product.zones.map((zone, zIdx) => {
                                  // Find the corresponding zone price for the current weight range
                                  const zonePrice = range.zone_prices.find(zp => zp.zone_id === zone.zone_id);
                                  return (
                                      <td key={zIdx} style={{ border: '1px solid #ddd', padding: '8px' }}>
                                          {zonePrice ? zonePrice.price : "N/A"}
                                      </td>
                                  );
                              })}
                          </tr>
                      ))}
                      <tr>
                          <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              Additional per {product.additional_weight} KG
                          </td>
                          {product.zones.map((zone, zIdx) => {
                              // Find the additional price for the corresponding zone
                              const additionalPrice = product.additionalPrices.find(ap => ap.zone_id === zone.zone_id)?.additional_price || "N/A";
                              return (
                                  <td key={zIdx} style={{ border: '1px solid #ddd', padding: '8px' }}>
                                      {additionalPrice}
                                  </td>
                              );
                          })}
                      </tr>
                  </tbody>
              </table>
          </div>
      )):""}
    </section>
  </div>
  )
}

export default Pricing_chart
